<template>
    <div v-click-outside.stop="hideVariablesTooltip" class="template-guidelines">
        <div class="tooltip-container">
            <span class="tooltip-text tooltip-text--bottom text-left" v-bind:class="{'tooltip-visible' : true}">
                <h5>WhatsApp Template Guidelines</h5>
                <ul>
                    <li>The template can't end with a personalisation variable</li>
                    <li>It mustn't contain too many personalisations relative to the message length</li>
                    <li>The template can't be a duplicate of another template</li>
                    <!-- <li>You can't impersonate another business</li> -->
                    <!-- <li>It mustn't contain potentially abusive or threatening content</li> -->
                    <li>Do not request sensitive identifiers from guests - e.g. do not ask guests 
                        to share full length credit card numbers, send a copy of their ID etc</li>
                    <li>See the full <a href="https://business.whatsapp.com/policy" target="_blank">WhatsApp Business Policy</a></li>
                </ul>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TemplateGuidelines',
    mixins: [],
    data() {
        return {
        };
    },
    computed: {
    },
    methods: {
        hideVariablesTooltip: function() {
            this.$emit('hide-template-guidelines');
        }
    }
};
</script>

<style lang="scss" scoped>
  @import "../../styles/components/template_guidelines.scss";
</style>